/* RESPONSIBLE TEAM: team-automation-foundations */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Fin from 'embercom/models/operator/visual-builder/step/fin';

export default class FinHasSdrConfig extends BaseValidator {
  @service declare intl: IntlService;

  validate(_value: unknown, _options: ValidationOptions, model: Fin) {
    if (!model.isFinSdr) {
      return true;
    }

    if (model.hasSdrConfig === null) {
      return true; // still loading, avoid invalid flash
    }

    if (!model.hasSdrConfig) {
      return this.intl.t('ai-agent.profiles.validation-errors.sdr-config-not-ready');
    }

    return true;
  }

  static getDependentsFor() {
    return [
      'model.selectedAgent',
      'model.selectedAgentValue',
      'model.isFinSdr',
      'model.hasSdrConfig',
    ];
  }
}
